/* eslint-disable */
import { Component, ElementRef, NgZone, OnInit, ViewChild } from '@angular/core';
import { AlertController, ModalController, NavParams } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { CONSTANTS } from 'src/app/services/config.service';
import { LoggerService } from 'src/app/services/logger.service';
import { MapsService } from 'src/app/services/maps.service';
import { PointsHelperService } from 'src/app/services/points-helper.service';
import { PubSubService } from 'src/app/services/pub-sub.service';
import { MSRemoteLoggerCategory } from 'src/app/adapters/remote-logger/utils/remote-logger.utils';

@Component({
  selector: 'app-survey-geocoder-browser',
  templateUrl: './survey-geocoder-browser.page.html',
  styleUrls: ['./survey-geocoder-browser.page.scss']
})
export class SurveyGeocoderBrowserPage implements OnInit {
  @ViewChild('map') mapElement: ElementRef;
  @ViewChild('placesMap') placesMap: ElementRef;

  data: any = {};
  survey: any = {};
  point: any;
  center: any;

  searchType = 'search';

  query = '';
  // searchPlaceholder: string;
  searchResults: any = [];
  hasValidAccuracy: boolean;
  inaccurateMsg = {
    title: this.translate.instant('MAP_PLACE_SEARCH_INACCURATE'),
    snippet: this.translate.instant('MAP_PLACE_SEARCH_MORE_SPECIFIC')
  };
  invalidMapSearch = false;
  zoomedInEnough = false;

  nextDisabled: boolean;
  mapLoaded = false;
  placesLoaded = false;
  isDevice: boolean = CONSTANTS.IS_DEVICE;

  places: any = [];
  location: any;

  constructor(
    private navParams: NavParams,
    private zone: NgZone,
    private modalCtrl: ModalController,
    private alertCtrl: AlertController,
    private translate: TranslateService,
    private logger: LoggerService,
    private pointsHelper: PointsHelperService,
    private maps: MapsService,
    private pubSub: PubSubService
  ) {
    // this.searchPlaceholder = this.translate.instant('MAP_PLACE_SEARCH_LOADING');
    this.nextDisabled = true;

    this.pubSub.subscribe(CONSTANTS.EVENTS.mapViewChanged, (...args) => {
      this.logger.log('Map Changed', MSRemoteLoggerCategory.SURVEY_GEOCODER_BROWSER_PAGE);
      this.onViewChangeEnd();
    });
  }

  /************************************************************************************************************************************************************************
   * HELP
   ***********************************************************************************************************************************************************************/

  async onClickHelp() {
    this.maps.presentAlertGeocoderInstructions();
  }

  /************************************************************************************************************************************************************************
   * MANIPULATE MAP
   ***********************************************************************************************************************************************************************/

  addInfoWindow() {
    const data = {
      markerIdx: 0,
      content: this.getStartMarkerText()
    };

    this.maps.addInfoWindow(data);
  }

  getInfoWindowContent() {
    // let content: string;
    let title: string;
    let snippet = '';

    if (this.hasValidAccuracy === false) {
      return this.inaccurateMsg;
      // title = 'More accurate location required';
      // snippet = 'Please add a nearby street number, or click "Choose on map" above to fine-tune the location.</h5>';
      // return '<h5><strong>' + title + '</strong></h5><h5>' + snippet + '</h5>';
    }

    // title is based on geocoder vs geocoders question type
    if (this.data.question.type === 'geocoder') {
      title = this.data.item.text;
    } else {
      title = this.data.question.subtext + ' ' + this.data.item.text;
    }

    // if on browser, add class to the title and use a snippet
    if (!CONSTANTS.IS_DEVICE) {
      title = '<span class="info-window-title">' + title + '</span>';
      snippet = this.location ? this.location.name : this.data.item.place.name;
    } else {
      snippet = this.location ? this.location.name : this.data.item.place.name;
    }

    // content = '<div class="info-window-title>' + title + '</div>';
    // content += snippet ? '<div class="info-window-snippet>' + snippet + '</div>' : "";

    return { title, snippet };
  }

  getStartMarkerText() {
    let title: string;
    let snippet = '';

    if (this.hasValidAccuracy === false) {
      return this.inaccurateMsg;
    }

    // title is based on geocoder vs geocoders question type
    if (this.data.question.type === 'geocoder') {
      title = this.data.item.text;
    } else {
      title = this.data.question.subtext + ' ' + this.data.item.text;
    }

    // if on browser, add class to the title and use a snippet
    if (!CONSTANTS.IS_DEVICE) {
      title = '<span class="info-window-title">' + title + '</span>';
      snippet = this.location ? this.location.name : this.data.item.place.name;
    } else {
      snippet = this.location ? this.location.name : this.data.item.place.name;
    }

    return { title, snippet };
  }

  updateMapAndMarker() {
    if (this.maps.infoWindows.length > 0) {
      this.maps.closeInfoWindow(this.maps.infoWindows[0]);
    }

    this.maps.setMarkerPosition(this.maps.markers[0], { lat: this.location.lat, lng: this.location.lng });
    this.maps.setMarkerVisible(this.maps.markers[0], true);
    this.maps.setMapZoom(16);
    this.maps.setMapCenter({ lat: this.location.lat, lng: this.location.lng }).then(() => {
      this.addInfoWindow();
    });

    if (this.hasValidAccuracy) {
      this.nextDisabled = false;
    }
  }

  /************************************************************************************************************************************************************************
   * ADDRESS SEARCH
   ***********************************************************************************************************************************************************************/

  onAddressSearchEvent($event) {
    this.logger.log($event, MSRemoteLoggerCategory.SURVEY_GEOCODER_BROWSER_PAGE);

    if ($event.type === 'clear') {
      this.onClearSearch();
    } else {
      this.onSelectAddress($event);
    }
  }

  onSelectAddress(res) {
    this.location = res.location;
    this.hasValidAccuracy = res.hasValidAccuracy;
    this.updateMapAndMarker();
  }

  onClearSearch() {
    this.location = null;
    if (this.maps.infoWindows.length) {
      this.maps.closeInfoWindow(this.maps.infoWindows[0]);
    }
    this.maps.setMarkerVisible(this.maps.markers[0], false);
  }

  onClickSearchSegment() {
    this.searchType = 'search';
    this.nextDisabled = true;

    if (this.maps.infoWindows.length) {
      // close any infowindows
      this.maps.closeInfoWindow(this.maps.infoWindows[0]); //this.maps.infoWindows[0].close();
    }
  }

  /************************************************************************************************************************************************************************
   * MAP SEARCH
   ***********************************************************************************************************************************************************************/

  onViewChangeEnd() {
    if (this.searchType !== 'map') {
      return;
    }

    // page wasn't automatically updating. needed to add this
    this.zone.run(() => {
      this.invalidMapSearch = false;
      this.zoomedInEnough = this.maps.getZoom() >= 16;
      this.nextDisabled = true;
      if (this.zoomedInEnough) {
        this.location = this.maps.getMapCenter();
        this.maps
          .reverseGeocode(this.location)
          .then((res) => {
            this.location = res;
            this.nextDisabled = false;
          })
          .catch((res) => {
            // this.location.name = ""
            // this.logger.log(res);
            this.location.name = null;
            this.invalidMapSearch = true;
          });
      }
    });
  }

  onClickMapSegment() {
    this.searchType = 'map';
    this.query = '';
    this.searchResults = [];
    this.location = null;

    this.onViewChangeEnd();

    if (this.maps.infoWindows.length) {
      // close any infowindows
      this.maps.closeInfoWindow(this.maps.infoWindows[0]); //this.maps.infoWindows[0].close();
    }
    this.maps.setMarkerVisible(this.maps.markers[0], false);
  }

  /************************************************************************************************************************************************************************
   * MAP MODE
   ***********************************************************************************************************************************************************************/

  toggleSearchType() {
    if (this.searchType === 'search') {
      this.onClickMapSegment();
    } else {
      this.onClickSearchSegment();
    }
  }

  /************************************************************************************************************************************************************************
   * PREPARE DATA FOR STORING
   ***********************************************************************************************************************************************************************/

  getLatLon() {
    // can only get here if next enabled, meaning you have survey data for this location
    if (!this.location && this.searchType !== 'map') {
      return Promise.resolve(null);
    } // no need to update if started with a location and never changed

    return new Promise((resolve) => {
      if (this.searchType === 'map') {
        this.location = this.maps.getMapCenter();
        this.maps
          .reverseGeocode(this.location)
          .then((res) => {
            this.location.name = res['name'];
            this.location.lat = res['location'].latitude;
            this.location.lng = res['location'].longitude;

            const intLoc = this.pointsHelper.getIntPointsFromFloat([this.location])[0];
            resolve({
              lat: intLoc.lat,
              lon: intLoc.lon,
              name: this.translate.instant('MAP_MAP_SEARCH_PLACE_NEAR') + ' ' + this.location.name
            });
          })
          .catch((err) => {
            // this.logger.log(err);
            this.maps.setMarkerPosition(this.maps.markers[0], this.maps.getMapCenter());
            this.maps.addInfoWindow({ markerIdx: 0, content: { title: this.translate.instant('MAP_PLACE_SEARCH_BAD_GEOCODE') } });
          });
      } else {
        const intLoc = this.pointsHelper.getIntPointsFromFloat([this.location])[0];
        resolve({ lat: intLoc.lat, lon: intLoc.lon, name: this.location.name });
      }
    });
  }

  next() {
    let data: any;
    this.getLatLon()
      .then((res) => {
        data = res;
        if (this.maps) {
          return this.maps.removeMap(true);
        }
      })
      .then(() => {
        this.modalCtrl.dismiss(data);
      });
  }

  dismiss() {
    if (this.maps) {
      this.maps.removeMap(true).then(() => {
        this.modalCtrl.dismiss();
      });
    } else {
      this.modalCtrl.dismiss();
    }
  }

  init() {
    this.logger.log('ionViewDidLoad SurveyGeocoderPage', MSRemoteLoggerCategory.SURVEY_GEOCODER_BROWSER_PAGE);

    this.logger.log('cur lang', MSRemoteLoggerCategory.SURVEY_GEOCODER_BROWSER_PAGE, this.translate.currentLang);
    // this.translate.use(this.translate.currentLang);

    // get searchbar element and disable until map is loaded
    const inputs: any = document.getElementById('searchbar-input').getElementsByTagName('INPUT');
    inputs[0].disabled = true;

    // navParams passes the question, the item (including a JSON parsed location object), and surveyData (so we can use homeLoc for centering the map)
    this.data = this.navParams.data;
    // get the place obj
    const place = this.data.item.place;

    // if we already have a place, center the map there
    if (place) {
      this.point = this.pointsHelper.getFloatPointsFromInt([{ lat: place.lat, lon: place.lon }])[0];
      this.center = this.point;
      // if we don't have a point, center on the homeLoc if we have it
    } else if (this.data.surveyData.hhHome) {
      const obj = JSON.parse(this.data.surveyData.hhHome);
      this.center = this.pointsHelper.getFloatPointsFromInt([{ lat: obj.lat, lon: obj.lon }])[0];
    }

    return this.maps
      .init(this.mapElement.nativeElement, this.center, null)
      .then(() => {
        this.logger.log('SURVEY GEOCODER WORKED', MSRemoteLoggerCategory.SURVEY_GEOCODER_BROWSER_PAGE);
        let startMarkerOpts = {};
        let ifVisibleOpts = {};

        startMarkerOpts = {
          position: this.center ? this.center : CONSTANTS.MAPS.DEFAULT_MAP_CENTER,
          visible: this.point != null,
          icon: { url: './assets/imgs/marker-generic.svg' }
        };

        // if we have a start point, we add more options. if we add these and the marker is not visible, things break, at least in native
        // if (this.point) {
        ifVisibleOpts = {
          styles: {
            'text-align': 'center'
          }
        };
        // }

        startMarkerOpts = Object.assign(startMarkerOpts, ifVisibleOpts);

        // zoom out from home loc if work/school so users less likely to choose home loc as work or school loc
        if (this.data.question && this.data.question.type === 'geocoders') {
          // if we have place - i.e., the user has answered and re-entered this page, use the map service default zoom of 16
          // however, if we have a home loc as our center, zoom out a bit
          if (!place && this.center) {
            this.maps.setMapZoom(13);
          }
        }

        return this.maps.addMarker(startMarkerOpts);
      })
      .then(() => {
        if (this.point) {
          this.addInfoWindow();
        }

        this.maps.addViewChangeEndEvent();

        return this.maps.loadPlacesService(this.placesMap.nativeElement, this.center, null);
      })
      .then((res) => {
        if (res) {
          // this.searchPlaceholder = this.translate.instant('MAP_PLACE_SEARCH_SEARCH');
          inputs[0].disabled = false;
        }

        if (this.point) {
          this.nextDisabled = false;
        }

        this.mapLoaded = true;
      })
      .catch((err) => {
        this.logger.log('SURVEY GEOCODER ERROR: ', MSRemoteLoggerCategory.SURVEY_GEOCODER_BROWSER_PAGE, err);
      });
  }

  ionViewDidEnter() {
    this.init();
  }

  ngOnInit() {}

  ngOnDestroy() {
    if (this.maps) {
      this.maps.removeMap(true);
    }
  }
}
